import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=17320ff8&scoped=true&"
import script from "./GoodList.vue?vue&type=script&lang=js&"
export * from "./GoodList.vue?vue&type=script&lang=js&"
import style0 from "./GoodList.vue?vue&type=style&index=0&id=17320ff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17320ff8",
  null
  
)

export default component.exports